import { createCrudPage } from './factories/crud-page.js';

const basePath = '/order';

export default createCrudPage({
  title: 'Orders',
  basePath,
  columns: [
    { key: 'order_id', label: 'ID', sortable: true },
    { key: 'order_name', label: 'Name', sortable: true },
    { key: 'order_date', label: 'Date', sortable: true },
    { key: 'order_price', label: 'Price', sortable: true },
    { key: 'payment_type', label: 'Payment', sortable: true },
    { key: 'order_send_date', label: 'Send Date', sortable: true },
    { key: 'order_payed', label: 'Payed', sortable: true,
      render: (v) => v == 1 ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'order_name', label: 'Name', type: 'text' },
    { key: 'order_phone', label: 'Phone', type: 'readonly' },
    { key: 'order_street', label: 'Street', type: 'readonly' },
    { key: 'order_city', label: 'City', type: 'readonly' },
    { key: 'order_email', label: 'Email', type: 'readonly' },
    { key: 'woj', label: 'Woj', type: 'async-select',
      optionsUrl: '/regions/options' },
    { key: 'order_company', label: 'Company', type: 'readonly' },
    { key: 'order_nip', label: 'Company VAT', type: 'readonly' },
    { key: 'order_comp_street', label: 'Company street', type: 'readonly' },
    { key: 'order_comp_city', label: 'Company city', type: 'readonly' },
    { key: 'order_pay', label: 'Payment options', type: 'async-select',
      optionsUrl: '/payment-types/options' },
    { key: 'order_price', label: 'Price', type: 'readonly' },
    { key: 'order_post', label: 'Shipping', type: 'readonly' },
    { key: 'order_order', label: 'Description', type: 'readonly' },
    { key: 'order_date', label: 'Date', type: 'datetime' },
    { key: 'order_payed', label: 'Payed', type: 'readonly' },
    { key: 'prenumerata', label: 'Subscription', type: 'readonly' },
    { key: 'order_post_type', label: 'Post type', type: 'readonly' },
    { key: 'order_post_country', label: 'Post country', type: 'readonly' },
    { key: 'order_send_date', label: 'Send date', type: 'datetime' },
  ],
  filters: [
    { key: 'name', label: 'Name', type: 'text' },
    { key: 'email', label: 'Email', type: 'text' },
    { key: 'order_id', label: 'Order ID', type: 'text' },
    { key: 'product', label: 'Product', type: 'text' },
    { key: 'payed', label: 'Payed', type: 'radio',
      options: [
        { value: '', label: 'All' },
        { value: '1', label: 'Yes' },
        { value: '0', label: 'No' },
      ] },
    { key: 'paymentType', label: 'Payment Type', type: 'select',
      optionsUrl: '/payment-types/options' },
    { key: 'dateFrom', label: 'Date From', type: 'date' },
    { key: 'dateTo', label: 'Date To', type: 'date' },
  ],
  rowActions: [
    { key: 'edit', label: 'Edit' },
    { key: 'payed', label: 'Mark Payed', icon: 'check',
      confirm: 'Mark this order as payed?',
      visible: (row) => row.order_payed != 1 },
    { key: 'not_payed', label: 'Mark Not Payed', icon: 'times',
      confirm: 'Mark this order as not payed?',
      visible: (row) => row.order_payed == 1 },
    { key: 'sent', label: 'Mark Sent', icon: 'truck',
      confirm: 'Mark this order as sent?',
      visible: (row) => !row.order_send_date },
    { key: 'not_sent', label: 'Mark Not Sent', icon: 'undo',
      confirm: 'Mark this order as not sent?',
      visible: (row) => !!row.order_send_date },
    { key: 'delete', label: 'Delete', variant: 'danger',
      confirm: 'Are you sure you want to remove this row?' },
  ],
  customActions: (ctx) => ({
    payed: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { order_payed: 1 },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
    not_payed: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { order_payed: 0 },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
    sent: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { order_send_date: new Date().toISOString() },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
    not_sent: async (row) => {
      const id = String(row?.[ctx.rowKey] ?? '').trim();
      if (!id) return;
      await ctx.services.apiClient.patch(
        `${basePath}/${encodeURIComponent(id)}`, { order_send_date: null },
        { signal: ctx.services.signal },
      );
      ctx.grid.refresh();
    },
  }),
  rowKey: 'order_id',
  defaultSort: { field: 'order_id', dir: 'desc' },
});
